// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"48":"06b8dddd","290":"9cb70ea9","853":"38b61255"}[chunkId] + ".js";
};